import React from 'react';
import { formaterPrix } from '../services/format';

export default function SelectionVariante({ variantes, value, onChange }) {
  return (
    <div className="grid gap-2">
      <div className="text-xs font-semibold text-gray-600">Variante</div>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
        className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 focus:outline-none"
      >
        <option value="">Sélectionner</option>
        {(variantes || []).map((v) => (
          <option key={v.id} value={v.id}>
            {v.nom_variante} : {v.valeur_variante} ({formaterPrix(v.prix)}) - Stock {v.stock}
          </option>
        ))}
      </select>
    </div>
  );
}
